'use client';

//* Styles
import HomeTemplateStyle from './style';

//* Components
import HeroHome from '../components/Hero';
import PerfectLocation from '../components/PerfectLocation';
import AboutHome from '../components/About';
import Benefits from '../components/Benefits';
import SliderReviews from '../components/SliderReviews';
import CallToAction from '../../_sections/CallToAction';
import Cooking from '../../Recipes/individual/components/Cooking';
import ProductsSlider from '../components/Products';
import FAQComp from '../../_sections/FAQComp';

const HomeTemplate = ({ pageData }) => {
	return (
		<HomeTemplateStyle id={'full-pad'}>
			<HeroHome {...pageData.hero} />
			<PerfectLocation {...pageData.location} />

			<AboutHome {...pageData.about} />

			<Benefits {...pageData.benefits} />

			<ProductsSlider data={pageData.products} />

			<SliderReviews pageData={pageData.reviews} />

			<FAQComp />

			<Cooking isHome />

			<CallToAction />
		</HomeTemplateStyle>
	);
};

export default HomeTemplate;
